const awsmobile = {
  "aws_project_region": "us-west-2",
  "aws_cognito_region": "us-west-2",
  "aws_user_pools_id": "us-west-2_sTIHwg2SD",
  "aws_user_pools_web_client_id": "58or4h9ipg19578t4lvegn9k80",
  "oauth": {}  // Additional OAuth configuration if needed
};

export default awsmobile;